export const SET_LOGIN_MESSAGE = "SET_LOGIN_MESSAGE";
export const SET_USER_LOGIN_STATUS = "SET_USER_LOGIN_STATUS";
export const SET_USER_ID = "SET_USER_ID";
export const START_LOGIN_LOADING = "START_LOGIN_LOADING";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_REGISTRATION = "USER_REGISTRATION";
export const SET_USER_EMAIL = "SET_USER_EMAIL";
